<app-filter-lozenge
  *ngIf="appliedFiltersByType.length > 0"
  #filterLozenge
  [isFixedFilter]="isFixedFilter"
  [appliedFiltersByType]="appliedFiltersByType"
  (click)="openEditContainerModal()"
  (removed)="onLozengeRemoved($event)"
>
</app-filter-lozenge>
